<template>
  <div class="modal-overlay" v-if="visible" @click.self="$emit('cancel')">
    <div class="modal-card form-modal">
      <h2 class="modal-title">{{ isEditing ? 'Editar acampante' : 'Novo acampante' }}</h2>

      <form @submit.prevent="handleSubmit" class="form">
        <div class="form-group">
          <label class="label" for="acampante-name">Nome completo *</label>
          <input
            id="acampante-name"
            class="input"
            type="text"
            v-model="form.name"
            placeholder="Ex: João da Silva"
            autocomplete="off"
          />
          <span class="error-msg" v-if="errors.name">{{ errors.name }}</span>
        </div>

        <div class="form-group">
          <label class="label" for="acampante-contato">Contato</label>
          <input
            id="acampante-contato"
            class="input"
            type="tel"
            v-model="form.contato"
            placeholder="(11) 99999-0000"
            autocomplete="off"
          />
        </div>

        <div class="form-group">
          <label class="label">Equipe</label>
          <EquipeSelector v-model="form.equipe" />
          <span class="error-msg" v-if="errors.equipe">{{ errors.equipe }}</span>
        </div>

        <div class="form-group">
          <label class="label" for="acampante-valor-total">Valor total (R$)</label>
          <input
            id="acampante-valor-total"
            class="input"
            type="text"
            inputmode="decimal"
            v-model="form.valorTotal"
            placeholder="320,00"
            autocomplete="off"
          />
          <span class="hint-msg">Total que este acampante deve pagar. Deixe em branco se ainda não definido.</span>
          <span class="error-msg" v-if="errors.valorTotal">{{ errors.valorTotal }}</span>
        </div>

        <div class="modal-actions">
          <button type="button" class="btn-secondary" @click="$emit('cancel')">Cancelar</button>
          <button type="submit" class="btn-primary" :disabled="submitting">
            <span v-if="!submitting">{{ isEditing ? 'Salvar' : 'Cadastrar' }}</span>
            <span v-else>Salvando...</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import EquipeSelector from './EquipeSelector.vue'
import { EQUIPES } from '../lib/equipes'

const EQUIPE_VALUES = EQUIPES.map(e => e.value)

export default {
  name: 'AcampanteForm',
  components: { EquipeSelector },
  props: {
    visible: { type: Boolean, default: false },
    participant: { type: Object, default: null },
    submitting: { type: Boolean, default: false }
  },
  emits: ['save', 'cancel'],
  data() {
    return {
      form: this.emptyForm(),
      errors: {}
    }
  },
  computed: {
    isEditing() { return !!this.participant }
  },
  watch: {
    visible(open) {
      if (!open) return
      this.errors = {}
      if (this.participant) {
        this.form = {
          name: this.participant.name || '',
          contato: this.participant.contato || '',
          equipe: this.participant.equipe || null,
          valorTotal: this.participant.valorTotal != null
            ? String(this.participant.valorTotal).replace('.', ',')
            : ''
        }
      } else {
        this.form = this.emptyForm()
      }
    }
  },
  methods: {
    emptyForm() {
      return { name: '', contato: '', equipe: null, valorTotal: '' }
    },
    parseValor(raw) {
      if (raw === null || raw === undefined) return null
      const s = String(raw).trim()
      if (!s) return null
      const n = Number(s.replace(/[R$\s]/g, '').replace(',', '.'))
      if (!Number.isFinite(n) || n < 0) return Number.NaN
      return Math.round(n * 100) / 100
    },
    validate() {
      const errors = {}
      const name = (this.form.name || '').trim()
      if (name.length < 2) errors.name = 'Nome deve ter ao menos 2 caracteres'
      if (this.form.equipe !== null && !EQUIPE_VALUES.includes(this.form.equipe)) {
        errors.equipe = 'Equipe inválida'
      }
      const valorTotal = this.parseValor(this.form.valorTotal)
      if (Number.isNaN(valorTotal)) errors.valorTotal = 'Valor inválido'
      this.errors = errors
      return Object.keys(errors).length === 0
    },
    handleSubmit() {
      if (!this.validate()) return
      this.$emit('save', {
        data: {
          name: this.form.name.trim(),
          contato: (this.form.contato || '').trim() || null,
          equipe: this.form.equipe,
          valorTotal: this.parseValor(this.form.valorTotal)
        }
      })
    }
  }
}
</script>

<style scoped>
.form-modal { max-width: 460px; }
.form { display: flex; flex-direction: column; gap: var(--spacing-base); }
.form-group { display: flex; flex-direction: column; }
.hint-msg {
  font-size: var(--text-xs);
  color: var(--color-text-muted);
  margin-top: var(--spacing-xs);
}
</style>
